import React from 'react';

interface DropdownProps {
  label: string;
  placeholder: string;
  value: string;
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const Dropdown: React.FC<DropdownProps> = ({
  label,
  placeholder,
  value,
  options,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-body font-roboto font-medium text-figma-text">
        {label}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full px-4 py-2.5 bg-figma-card text-figma-text font-roboto text-body 
                   border border-figma-mint rounded-figma-button 
                   focus:outline-none focus:ring-2 focus:ring-figma-mint focus:border-figma-mint
                   disabled:opacity-50 disabled:cursor-not-allowed
                   transition-smooth hover:border-figma-mint"
      >
        {!value && <option value="" disabled>{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
